import axios from 'axios'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

const Signup = () => {
  const[username,setUsername] = useState('')
  const[email,setEmail]=useState('')
  const[phone,setPhone]=useState('')
  const[password,setPassword] = useState('')
  //response states
  const[success,setSuccess]= useState('')
  const[loading,setLoading]=useState('')
  const[error,setError]= useState('')

  const navigate =useNavigate();


  const handleSubmit = async(e)=>{
    e.preventDefault();
    setLoading('Connecting ...')
    try{
      // fetching data from form
      const formData=new FormData();
      formData.append('username',username)
      formData.append('email',email)
      formData.append('phone',phone)
      formData.append('password',password)
      //posting data
      const response = await axios.post('https://40b.pythonanywhere.com/api/signup',formData)
      setLoading('')
      setSuccess(response.data.success)
      navigate("/signin");

    }catch(error){
      setError(error.message)

    }

  }
  return (
    <div className="row justify-content-center mt-4">
      <div className="shadow card col-md-6 p-4">
        <h1>Sign Up Form</h1>
        {loading}
        {success}
        {error}
        <form action="" onSubmit={handleSubmit }> 
          {/*phone input */}
          <input
            type="text"
            placeholder="Enter Username"
            className="form-control"
            value={username}
            onChange={(e) => {
              setUsername(e.target.value);
            }}
          />
          <br />

          {/**Email input */}
          <input
            type="email"
            placeholder="Enter Email"
            className="form-control"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
          <br />

          {/**Phone input */}
          <input
            type="tel"
            placeholder="Enter Phone"
            className="form-control"
            value={phone}
            onChange={(e) => {
              setPhone(e.target.value);
            }}
          />
          <br />

          {/**Password input */}
          <input
            type="password"
            placeholder="Enter Password"
            className="form-control"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
          />{" "}
          <br />
          <button type="submit" className="btn btn-primary">Sign Up</button>
          <p>Already have an account?<Link to="/signin">Sign in</Link> </p>
        </form>
      </div>
    </div>
  );
}

export default Signup